import { Component, ErrorInfo, ReactNode } from 'react'

import { ILogRequest, ILogResponse } from '@/pages/api/log'
import { meetAxiosInstance } from '@/src/constants/fetches'

import { AxiosResponse } from 'axios'

interface ErrorBoundaryProps {
  children: ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
  error?: Error
  errorInfo?: ErrorInfo
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = {
      hasError: false,
      error: undefined,
      errorInfo: undefined,
    }
  }

  static getDerivedStateFromError(error: Error): Partial<ErrorBoundaryState> {
    return {
      hasError: true,
      error: error,
    }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({
      error,
      errorInfo,
    })

    meetAxiosInstance
      .post<ILogResponse, AxiosResponse<ILogResponse>, ILogRequest>('/api/log', {
        message: `Global error in Front-end application caught in ErrorBoundary: ${
          error?.message || 'Unknown error message'
        }, ${errorInfo?.componentStack || 'Unknown error info component stack'}, ${
          errorInfo?.digest || 'Unknown error info digest'
        }`,
      })
      .catch((err) => {
        console.error('Error with logging message from ErrorBoundary: \n', err)
      })
  }

  handleReset = () => {
    this.setState({
      hasError: false,
      error: undefined,
      errorInfo: undefined,
    })
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div
          style={{
            width: 350,
            height: '100%',
            margin: 'auto',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            textAlign: 'center',
          }}
        >
          <h2 style={{ width: '100%', textAlign: 'center', fontWeight: 500, fontSize: '1.75rem' }}>
            Что-то пошло не так...
          </h2>

          <a
            href=""
            onClick={this.handleReset}
            style={{
              marginTop: '15px',
              padding: '8px 16px',
              background: 'var(--lk-danger)',
              color: 'white',
              fontSize: '1rem',
              borderRadius: '8px',
              textDecoration: 'none',
            }}
          >
            Перезагрузить страницу
          </a>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
